import { render, staticRenderFns } from "./FolderDiff.vue?vue&type=template&id=6bde6a8d&scoped=true&functional=true&"
import script from "./FolderDiff.vue?vue&type=script&lang=js&"
export * from "./FolderDiff.vue?vue&type=script&lang=js&"
import style0 from "./FolderDiff.vue?vue&type=style&index=0&id=6bde6a8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6bde6a8d",
  null
  
)

export default component.exports